export default {
  common: {
    active: 'Activo',
    add: 'Añadir',
    advancedFunctions: 'Funciones avanzadas',
    and: 'y',
    appName: 'Arena',
    appNameFull: '$t(common.openForis) Arena',
    apply: 'Aplicar',
    aggregateFunction: 'Función de agregación',
    aggregateFunction_other: 'Funciones de agregación',
    attribute: 'Atributo',
    attribute_other: 'Atributos',
    avg: 'Promedio',
    ascending: 'Ascendente',
    areaBased: 'basado en el área',
    back: 'Atrás',
    baseUnit: 'Unidad base',
    cancel: 'Cancelar',
    cancelConfirm: '**Hay cambios sin guardar**. \n¿Desea ignorarlos?',
    cantUndoWarning: 'Esta operación no se puede deshacer',
    cantBeDeletedUsedItem: 'Este {{item}} es utilizado por algunas definiciones de nodo y no puede ser eliminado',
    chain: 'Cadena',
    chain_plural: 'Cadenas',
    childrenEmpty: 'Defina al menos un elemento hijo',
    clear: 'Limpiar',
    clone: 'Clonar',
    close: 'Cerrar',
    cloneFrom: 'Clonar de',
    cnt: 'Contar',
    code: 'Código',
    collapse: 'Colapsar',
    confirm: 'Confirmar',
    convert: 'Convertir',
    copy: 'Copiar',
    createdWith: 'Creado con',
    createdWithApp: '$t(common.createdWith) {{app}}',
    cycle: 'Ciclo',
    cycle_plural: 'Ciclos',
    dateCreated: 'Fecha de creación',
    dateLastModified: 'Fecha de última modificación',
    delete: 'Eliminar',
    deleted: '¡Eliminado!',
    descending: 'Descendente',
    description: 'Descripción',
    description_plural: 'Descripciones',
    designerNotes: 'Notas del diseñador',
    designerNotesInfo:
      'Las notas del diseñador solo serán visibles en el diseñador del formulario de la encuesta y no serán visibles en el formulario de entrada de datos.',
    details: 'Detalles',
    dimension: 'Dimensión',
    dimension_other: 'Dimensiones',
    done: 'Hecho',
    download: 'Descargar',
    draft: 'Borrador',
    edit: 'Editar',
    email: 'Correo electrónico',
    email_other: 'Correos electrónicos',
    emailSentConfirmation:
      'Se ha enviado un correo electrónico a {{email}}. \nPor favor, informe a la persona que revise también la carpeta de correo no deseado/spam.',
    emailSentToSelfConfirmation:
      'Debería haber recibido un correo electrónico a {{email}}. \nPor favor, revise también la carpeta de correo no deseado/spam.',
    empty: 'Vacío',
    entity: 'Entidad',
    error: 'Error',
    error_plural: 'Errores',
    errorFound: '1 error encontrado',
    errorFound_other: '{{count}} errores encontrados',
    errorMessage: 'Mensaje de error',
    errorMessage_plural: 'Mensajes de error',
    expand: 'Expandir',
    expandCollapse: '$t(common.expand) / $t(common.collapse)',
    export: 'Exportar',
    exportAll: 'Exportar todo',
    exportToCSV: 'Exportar a CSV',
    exportToExcel: 'Exportar a Excel',
    exportToExcelTooManyItems: 'Demasiados elementos para exportar a Excel; por favor, use la exportación a CSV.',
    expression: 'Expresión',
    false: 'Falso',
    file: 'Archivo',
    file_plural: 'Archivos',
    formContainsErrors: 'El formulario contiene errores',
    formContainsErrorsCannotContinue: 'El formulario contiene errores. Por favor, corríjalos antes de continuar.',
    formContainsErrorsCannotSave: 'El formulario contiene errores. Por favor, corríjalos antes de guardar.',
    from: 'Desde',
    function: 'Función',
    goToHomePage: 'Ir a la página de inicio',
    goToSurveys: 'Ir a encuestas',
    group: 'Grupo',
    help: 'Ayuda',
    hide: 'Ocultar',
    id: 'id',
    import: 'Importar',
    importFromExcelOrCSVFile: 'Importar desde archivo Excel (.xlsx) o CSV',
    info: 'Información',
    invalid: 'INVÁLIDO',
    item: 'Artículo',
    item_plural: 'Artículos',
    itemAlreadyAdded: 'Artículo ya añadido',
    label: 'Etiqueta',
    label_plural: 'Etiquetas',
    language: 'Idioma',
    language_plural: 'Idiomas',
    leavePageConfirmMessage:
      'Hay cambios sin guardar en el formulario. \nAl confirmar, todos los cambios se perderán. \n¿Desea continuar?',
    local: 'Local',
    loading: 'Cargando...',
    lock: 'Bloquear',
    unlock: 'Desbloquear',
    max: 'Máximo',
    med: 'Mediana',
    manage: 'Administrar',
    message_plural: 'Mensajes',
    measure: 'Medida',
    measure_other: 'Medidas',
    measurePrevSteps: 'Medir pasos previos',
    measurePrevSteps_plural: 'Medidas pasos previos',
    min: 'Mínimo',
    name: 'Nombre',
    new: 'Nuevo',
    next: 'Siguiente',
    no: 'No',
    noItems: '$t(common.no) $t(common.item_plural)',
    notSpecified: '---No especificado---',
    orderBy: 'Ordenar por',
    of: 'de',
    ok: 'Ok',
    openForis: 'Open Foris',
    openForisShort: 'OF',
    openInNewWindow: 'Abrir en una nueva ventana',
    options: 'Opciones',
    owner: 'Propietario',
    path: 'Ruta',
    pause: 'Pausar',
    preview: 'Modo de vista previa',
    previous: 'Anterior',
    publish: 'Publicar',
    publishConfirm:
      '#### Está a punto de publicar la encuesta {{survey}} ####\n\n###### El proceso de publicación *eliminará permanentemente* la siguiente información ###### \n- Etiquetas asociadas a idiomas eliminados.\n- Registros asociados a ciclos eliminados.\n- Datos asociados a campos de formulario eliminados.\n\n###### Después de publicar: ###### \n- Los campos de formulario no se pueden cambiar de único a múltiple y viceversa.\n- Los códigos de elementos de categoría no se pueden cambiar.\n- Los elementos de categoría no se pueden eliminar.\n- Los códigos de taxonomía no se pueden cambiar.\n- Los taxones no se pueden eliminar.\n\n**¿Está seguro de que desea continuar?**',
    raiseTicketInSupportForum:
      "En caso de problemas, por favor, abra un ticket con la etiqueta 'arena' en nuestro <b>Foro de soporte</b>: $t(links.supportForum)",
    record: 'Registro',
    record_other: 'Registros',
    remote: 'Remoto',
    required: 'Requerido',
    requiredField: 'campo requerido',
    reset: 'Reiniciar',
    refresh: 'Refrescar',
    pressRefreshToReloadPage: 'Pulsa Actualizar para recargar la página.',
    resume: 'Reanudar',
    retry: 'Reintentar',
    role: 'Rol',
    save: 'Guardar',
    saveAndBack: 'Guardar y volver',
    saved: '¡Guardado!',
    samplingPolygon: 'Polígono de muestreo',
    show: 'Mostrar',
    select: 'Seleccionar',
    selectOne: 'Seleccione uno...',
    selectAll: 'Seleccionar todo',
    selected: 'Seleccionado',
    showLabels: 'Mostrar etiquetas',
    showLabelsAndNames: 'Mostrar etiquetas y nombres',
    showNames: 'Mostrar nombres',
    sort: 'Ordenar',
    sortAsc: 'Ordenar ascendente',
    sortDesc: 'Ordenar descendente',
    sortNone: 'Quitar orden',
    srs: 'SRS',
    status: 'Estado',
    sum: 'Suma',
    test: 'Prueba',
    to: 'A',
    totalItems: 'Total de elementos',
    true: 'Verdadero',
    trySplittingFileIntoSmallerChunks: 'Intente dividir el archivo en partes más pequeñas.',
    type: 'Tipo',
    undefinedName: 'Nombre indefinido',
    unique: 'Único',
    upload: 'Subir',
    uploadErrorConfirm: {
      message: `Error durante la carga del archivo: {{error}}.\n
¿Intentar de nuevo?`,
    },
    uploadFileChangedError:
      'El archivo seleccionado parece haber sido modificado desde que fue seleccionado. Por favor, selecciónelo de nuevo.',
    uploadingFile: 'Subiendo archivo ({{progressPercent}}%)',
    value: 'Valor',
    view: 'Ver',
    warning: 'Advertencia',
    warning_plural: 'Advertencias',
    yes: 'Sí',
    date: {
      aMomentAgo: 'Hace un momento',
      hour: 'hora',
      hour_other: 'horas',
      day: 'día',
      day_other: 'días',
      minute: 'minuto',
      minute_other: 'minutos',
      week: 'semana',
      week_other: 'semanas',
      timeDiff: "Hace {{count}} $t(common.date.{{unit}}, { 'count': {{count}} })",
    },
    paginator: {
      firstPage: 'Primera página',
      itemsPerPage: 'Elementos por página',
      lastPage: 'Última página',
      nextPage: 'Página siguiente',
      previousPage: 'Página anterior',
    },
    table: {
      visibleColumns: 'Columnas visibles',
    },
  },
  confirm: {
    strongConfirmInputLabel: 'Para confirmar, escriba el siguiente texto: **{{strongConfirmRequiredText}}**',
  },
  dropzone: {
    acceptedFilesMessage: '(Solo se aceptarán archivos {{acceptedExtensions}} con un tamaño máximo de {{maxSize}})',
    error: {
      fileNotValid: 'El archivo seleccionado no es válido',
      fileTooBig: 'El archivo seleccionado es demasiado grande',
      invalidFileExtension: 'Extensión de archivo no válida: {{extension}}',
    },
    message: 'Arrastre y suelte un archivo aquí, o haga clic para seleccionarlo',
    selectedFile: 'Archivo seleccionado',
    selectedFile_other: 'Archivos seleccionados',
  },
  error: {
    pageNotFound: 'Página no encontrada',
  },
  geo: {
    area: 'Área',
    vertices: 'Vértices',
    perimeter: 'Perímetro',
  },
  files: {
    header: 'Archivos',
    missing: ' Archivos faltantes: {{count}}',
    totalSize: 'Tamaño total: {{size}}',
    fileName: 'Nombre del archivo',
    fileSize: 'Tamaño del archivo',
  },
  sidebar: {
    logout: 'Cerrar sesión',
  },
  header: {
    myProfile: 'Mi perfil',
    qrCodeLoginDialog: {
      title: 'Iniciar sesión en Arena Mobile usando código QR',
      instructions: `1. Abra la aplicación **Arena Mobile** en su dispositivo móvil
2. Vaya al menú de **Configuración**
3. Seleccione **Conexión al servidor**
4. Presione **Iniciar sesión usando código QR**
5. Escanee el código QR que se muestra en esta pantalla`,
      success: '¡Inicio de sesión exitoso!',
      error: 'Error al generar el código QR: {{error}}',
    },
  },
  nodeDefsTypes: {
    integer: 'Entero',
    decimal: 'Decimal',
    text: 'Texto',
    date: 'Fecha',
    time: 'Hora',
    boolean: 'Booleano',
    code: 'Código',
    coordinate: 'Coordenada',
    geo: 'Geoespacial',
    taxon: 'Taxón',
    file: 'Archivo',
    entity: 'Entidad',
  },
  appModules: {
    home: 'Inicio',
    landing: 'Bienvenida',
    dashboard: 'Panel de control',
    surveyNew: 'Nueva encuesta',
    surveys: 'Encuestas',
    templateNew: 'Nueva plantilla',
    templates: 'Plantillas',
    usersAccessRequest: 'Solicitudes de acceso de usuarios',
    collectImportReport: 'Informe de importación de Collect',
    surveyInfo: 'Información de la encuesta',
    designer: 'Encuesta',
    formDesigner: 'Diseñador de formularios',
    surveyHierarchy: 'Jerarquía',
    surveyDependencyTree: 'Árbol de dependencias',
    category: 'Categoría',
    categories: 'Categorías',
    nodeDef: 'Definición de nodo',
    taxonomy: 'Taxonomía',
    taxonomies: 'Taxonomías',
    data: 'Datos',
    record: '$t(common.record)',
    records: '$t(common.record_other)',
    recordValidationReport: 'Informe de validación de registro',
    explorer: 'Explorador',
    map: 'Mapa',
    charts: 'Gráficos',
    export: 'Exportación de datos',
    import: 'Importación de datos',
    validationReport: 'Informe de validación',
    users: 'Usuarios',
    user: 'Perfil de usuario',
    userPasswordChange: 'Cambiar contraseña',
    userInvite: 'Invitar usuario',
    userNew: 'Nuevo usuario',
    usersSurvey: 'Lista de usuarios',
    userGroup: 'Grupo de usuarios',
    userGroup_plural: 'Grupos de usuarios',
    userGroupNew: 'Nuevo grupo de usuarios',
    usersList: 'Lista de usuarios (todos)',
    user2FADevice: 'Dispositivo 2FA',
    user2FADevice_plural: 'Dispositivos 2FA',
    user2FADeviceDetails: '$t(appModules.user2FADevice)',
    user2FADeviceList: '$t(appModules.user2FADevice_plural)',
    analysis: 'Análisis',
    chain: 'Cadena',
    chain_plural: 'Cadenas',
    virtualEntity: 'Entidad virtual',
    entities: 'Entidades virtuales',
    virtualEntity_plural: '$t(appModules.entities)',
    instances: 'Instancias',

    jobMonitor: 'Monitor de trabajos',

    help: 'Ayuda',
    about: 'Acerca de',
    disclaimer: 'Descargo de responsabilidad',
    userManual: 'Manual de usuario',
  },
  surveyDefsLoader: {
    requireSurveyPublish: 'Esta sección solo está disponible cuando la encuesta está publicada',
  },
  loginView: {
    yourName: 'Su nombre',
    yourEmail: 'Su correo electrónico',
    yourPassword: 'Su contraseña',
    yourNewPassword: 'Su nueva contraseña',
    repeatYourPassword: 'Repita su contraseña',
    repeatYourNewPassword: 'Repita su nueva contraseña',
    requestAccess: '¿Nuevo en $t(common.appNameFull)? Solicitar acceso',
    resetPassword: 'Restablecer contraseña',
    login: 'Iniciar sesión',
    loginUsingBackupCode: 'Iniciar sesion con codigo de respaldo 2FA',
    forgotPassword: '¿Olvidó su contraseña?',
    sendPasswordResetEmail: 'Enviar correo electrónico de restablecimiento de contraseña',
    twoFactorBackupCode: 'Codigo de respaldo 2FA',
    twoFactorToken: 'Código de verificación',
    twoFactorTokenDescription: `Para mantener su cuenta segura, verificamos su identidad.

  Ingrese el código generado por su aplicación de autenticación.`,
  },
  accessRequestView: {
    error: 'Error al solicitar acceso: {{error}}',
    fields: {
      email: '$t(common.email)',
      props: {
        firstName: 'Nombre',
        lastName: 'Apellido',
        institution: 'Institución',
        country: 'País',
        purpose: '¿Para qué lo necesita?',
        surveyName: 'Proponer un nombre de encuesta',
        templateUuid: '¿Empezar desde una plantilla?',
      },
    },
    introduction:
      'Nuestros recursos son limitados, por lo que debe solicitar acceso a la plataforma. También nos interesa saber qué desea hacer con ella, ¡así que háganoslo saber! Tiene la posibilidad de empezar desde una **nueva encuesta en blanco** o clonar una **plantilla** existente y tendrá que sugerir un nombre para la nueva encuesta creada. Se le asignará el rol de ***Administrador de encuestas*** para esa encuesta: podrá editarla e invitar a nuevos usuarios a unirse a su encuesta y contribuir a ella. También será un ***Gerente de encuestas*** y podrá **crear nuevas encuestas** (hasta 5) si es necesario. Para obtener más información, visite nuestro sitio web: $t(links.openforisArenaWebsite) $t(common.raiseTicketInSupportForum) **Una vez que envíe la solicitud, espere un correo electrónico de invitación para acceder a Arena.**',
    reCaptchaNotAnswered: 'ReCaptcha no respondido',
    requestSent: 'Solicitud de acceso enviada correctamente',
    requestSentMessage:
      'Por favor, concédanos un par de días para procesar su solicitud. Le enviaremos pronto un correo electrónico a **{{email}}** con las instrucciones sobre cómo acceder a $t(common.appName). ¡Gracias y disfrute de **$t(common.appNameFull)**!',
    sendRequest: 'Enviar solicitud',
    sendRequestConfirm: '¿Solicitar acceso a $t(common.appNameFull)?',
    templateNotSelected: 'No seleccionado (empezar desde cero)',
    title: 'Solicitando acceso a $t(common.appNameFull)',
  },
  resetPasswordView: {
    title: {
      completeRegistration: 'Complete su registro en Arena',
      setYourNewPassword: 'Establezca su nueva contraseña',
    },
    setNewPassword: 'Establecer nueva contraseña',
    forgotPasswordLinkInvalid: 'La página a la que ha intentado acceder no existe o ya no es válida',
    passwordSuccessfullyReset: 'Su contraseña ha sido restablecida correctamente',
    passwordStrengthChecksTitle: 'Verificaciones de seguridad de la contraseña',
    passwordStrengthChecks: {
      noWhiteSpaces: 'Sin espacios en blanco',
      atLeast8CharactersLong: 'Al menos 8 caracteres',
      containsLowerCaseLetters: 'Contiene letras minúsculas',
      containsUpperCaseLetters: 'Contiene letras mayúsculas',
      containsNumbers: 'Contiene números',
    },
    completeRegistration: 'Completar registro',
  },
  surveyDependencyTreeView: {
    dependencyTypesLabel: 'Tipos de dependencia',
    dependencyTypes: {
      applicable: 'Aplicabilidad',
      defaultValues: 'Valor predeterminado',
      editable: 'Editable',
      fileName: 'Nombre de archivo',
      itemsFilter: 'Filtro de elementos',
      maxCount: 'Conteo máximo',
      minCount: 'Conteo mínimo',
      parentCode: 'Código padre',
      validations: 'Validaciones',
      visible: 'Visible',
    },
    selectAtLeastOneDependencyType: 'Seleccione al menos un tipo de dependencia',
    noDependenciesToDisplay: 'No hay dependencias para mostrar',
  },
  designerView: {
    formPreview: 'Vista previa del formulario',
  },
  recordView: {
    justDeleted: 'Este registro acaba de ser eliminado',
    sessionExpired: 'La sesión del registro ha expirado',
    errorLoadingRecord: 'Error al cargar el registro: {{details}}',
    recordEditModalTitle: 'Registro: {{keyValues}}',
    recordNotFound: 'Registro no encontrado',
    keyAttributeEditing: {
      lock: 'Bloquear edición del atributo clave',
      unlock: 'Permitir editar el atributo clave',
    },
    qualifierAttributeEditing: {
      lock: 'Bloquear edición del atributo calificador',
      unlock: 'Permitir editar el atributo calificador',
    },
  },
  dataExplorerView: {
    customAggregateFunction: {
      confirmDelete: '¿Eliminar esta función de agregación personalizada?',
      sqlExpression: 'Expresión SQL',
    },
    editRecord: 'Editar registro',
  },
  mapView: {
    changeMarkerColor: 'Cambiar color del marcador',
    createRecord: 'Crear nuevo registro',
    editRecord: 'Editar registro',
    elevation: 'Elevación (m)',
    location: 'Ubicación',
    locationEditInfo: 'Haga doble clic en el mapa o arrastre el marcador para actualizar la ubicación',
    locationNotValidOrOutOfRange: 'Ubicación no válida o fuera del rango de la zona UTM',
    locationUpdated: 'Ubicación actualizada',
    options: {
      showLocationMarkers: 'Mostrar marcadores de ubicación',
      showMarkersLabels: 'Mostrar etiquetas de marcadores',
      showSamplingPolygon: 'Polígono de muestreo',
      showControlPoints: 'Puntos de control',
      showPlotReferencePoint: 'Punto de referencia de parcela',
      showUtmGrid: 'Mostrar cuadrícula UTM',
    },
    samplingPointDataLayerName: 'Datos de puntos de muestreo - nivel {{level}}',
    samplingPointDataLayerNameLoading: '$t(mapView.samplingPointDataLayerName) (cargando...)',
    samplingPointItemPopup: {
      title: 'Elemento de punto de muestreo',
      levelCode: 'Código de nivel {{level}}',
    },
    selectedPeriod: 'Período seleccionado',
  },
  samplingPolygonOptions: {
    circle: 'Círculo',
    controlPointOffsetEast: 'Desplazamiento del punto de referencia este (m)',
    controlPointOffsetNorth: 'Desplazamiento del punto de referencia norte (m)',
    lengthLatitude: 'Longitud Latitud (m)',
    lengthLongitude: 'Longitud Longitud (m)',
    numberOfControlPoints: 'Número de puntos de control',
    numberOfPointsEast: 'Número de puntos de control este',
    numberOfPointsNorth: 'Número de puntos de control norte',
    offsetEast: 'Desplazamiento este (m)',
    offsetNorth: 'Desplazamiento norte (m)',
    radius: 'Radio (m)',
    rectangle: 'Rectángulo',
    samplingPolygon: 'Polígono de muestreo',
    shape: 'Forma',
  },
  kmlUploader: {
    opacity: 'opacidad',
    selectFile: 'Seleccionar archivo',
    title: 'Opciones de KML/KMZ/Shapefile',
  },
  mapBaseLayerPeriodSelector: {
    chooseAPeriodToCompareWith: 'Elija un período para comparar',
    falseColor: 'Color falso',
  },
  surveysView: {
    chains: 'Cadenas',
    confirmUpdateSurveyOwner: '¿Cambiar el propietario de la encuesta "{{surveyName}}" a "{{ownerName}}"?',
    cycles: 'Ciclos',
    datePublished: 'Fecha de publicación',
    editUserExtraProps: 'Editar propiedades adicionales de usuario',
    editUserExtraPropsForSurvey: 'Editar propiedades adicionales de usuario para la encuesta "{{surveyName}}"',
    filter: 'Filtro',
    filterPlaceholder: 'Filtrar por nombre, etiqueta o propietario',
    languages: 'Idiomas',
    nodes: 'Nodos',
    noSurveysMatchingFilter: 'No hay encuestas que coincidan con el filtro especificado',
    onlyOwn: 'Solo encuestas propias',
    records: 'Registros',
    recordsCreatedWithMoreApps: 'Registros creados con más aplicaciones:',
    status: {
      published: 'Publicada',
      draft: 'Borrador',
      'published-draft': 'Publicada/Borrador',
    },
  },
  usersAccessRequestView: {
    status: {
      ACCEPTED: 'Aceptado',
      CREATED: 'Pendiente',
    },
    acceptRequest: {
      accept: 'Aceptar',
      acceptRequestAndCreateSurvey: 'Aceptar solicitud y crear encuesta',
      confirmAcceptRequestAndCreateSurvey:
        '¿Aceptar la solicitud de acceso para **{{email}}** como **{{role}}** y crear una nueva encuesta **{{surveyName}}**?',
      error: 'Error al aceptar la solicitud de acceso: {{error}}',
      requestAcceptedSuccessfully: 'Solicitud de acceso aceptada correctamente. $t(common.emailSentConfirmation)',
      surveyLabel: 'Etiqueta de encuesta',
      surveyLabelInitial: '(Cambie el nombre y la etiqueta de la encuesta según sea necesario)',
      surveyName: 'Nombre de la encuesta',
      template: 'Plantilla',
    },
  },
  userView: {
    scale: 'Escala',
    rotate: 'Rotar',
    dragAndDrop: 'Arrastre y suelte una imagen aquí o',
    upload: 'haga clic aquí para subir',
    sendNewInvitation: 'Enviar nueva invitación',
    removeFromSurvey: 'Eliminar de la encuesta',
    confirmRemove: '¿Está seguro de que desea revocar el acceso de {{user}} a la encuesta {{survey}}?',
    removeUserConfirmation: 'El usuario {{user}} ha sido eliminado de la encuesta {{survey}}',
    maxSurveysUserCanCreate: 'Máximo de encuestas que el usuario puede crear',
    preferredUILanguage: {
      label: 'Idioma de interfaz de usuario preferido',
      auto: 'Detectado automáticamente ({{detectedLanguage}})',
    },
  },
  userPasswordChangeView: {
    changingPasswordForUser: 'Cambiando contraseña para el usuario: {{user}}',
    oldPassword: 'Contraseña antigua',
    newPassword: 'Nueva contraseña',
    confirmPassword: 'Confirmar nueva contraseña',
    changePassword: 'Cambiar contraseña',
    passwordChangedSuccessfully: '¡Contraseña cambiada correctamente!',
    notAuthorizedToChangePasswordOfAnotherUser: 'No está autorizado para cambiar la contraseña de otro usuario',
  },
  userInviteView: {
    confirmInviteSystemAdmin: '¿Invitar al usuario {{email}} como Administrador del Sistema?',
    confirmInviteSystemAdmin_other: '¿Invitar a los usuarios {{email}} como Administradores del Sistema?',
    emailSentConfirmationWithSkippedEmails:
      '$t(common.emailSentConfirmation)\n\n    $t(userInviteView.skippedEmailsNotice)',
    skippedEmailsNotice:
      'Se han omitido {{skppedEmailsCount}} direcciones (ya fueron invitadas a esta encuesta anteriormente): {{skippedEmails}}',
    groupPermissions: {
      label: 'Permisos',
      systemAdmin: '        <li>Derechos de acceso completos al sistema</li>',
      surveyManager:
        '        <li>Encuestas: \n          <ul>\n            <li>crear</li>\n            <li>clonar</li>\n            <li>editar encuestas propias</li>\n            <li>eliminar encuestas propias</li>\n          </ul>\n        </li>\n        <li>Usuarios:\n          <ul>\n            <li>invitar usuarios a encuestas propias</li>\n          </ul>\n        </li>\n        $t(userInviteView.groupPermissions.dataAnalyst)',
      surveyAdmin:
        '        <li>Encuestas: \n          <ul>\n            <li>clonar</li>\n            <li>editar encuestas propias</li>\n            <li>eliminar encuestas propias</li>\n          </ul>\n        </li>\n        <li>Usuarios:\n          <ul>\n            <li>invitar usuarios a encuestas propias</li>\n          </ul>\n        </li>\n        $t(userInviteView.groupPermissions.dataAnalyst)',
      surveyEditor:
        '        <li>Encuestas: \n          <ul>\n            <li>editar encuestas propias</li>\n          </ul>\n        </li>\n        $t(userInviteView.groupPermissions.dataAnalyst)',
      dataAnalyst:
        '        <li>Datos: \n          <ul>\n            $t(userInviteView.groupPermissions.dataCleanserData)\n            <li>acceso a la herramienta Mapa</li>\n          </ul>\n        </li>\n        <li>Análisis:\n          <ul>\n            <li>derechos de acceso completos a todas las herramientas</li>\n          </ul>\n        </li>',
      dataCleanser:
        '        <li>Datos: \n          <ul>\n            $t(userInviteView.groupPermissions.dataCleanserData)\n          </ul>\n        </li>',
      dataCleanserData:
        '        $t(userInviteView.groupPermissions.dataEditorData)\n        <li>acceso a las herramientas de validación de datos</li>\n        <li>enviar registros a la fase de “Análisis”</li>',
      dataEditor:
        '        <li>Datos: \n          <ul>$t(userInviteView.groupPermissions.dataEditorData)</ul>\n        </li>',
      dataEditorData:
        '        <li>añadir nuevos registros (encuestas propias)</li>\n        <li>editar registros existentes (encuestas propias)</li>\n        <li>enviar registros a la fase de “Limpieza”</li>',
    },
    messageOptional: 'Mensaje (opcional)',
    messageInfo:
      'El mensaje aparecerá en el correo electrónico enviado al usuario. Puede ser texto simple o lenguaje Markdown (https://www.markdownguide.org).',
    sendInvitation: 'Enviar invitación',
    surveyNotPublishedWarning:
      '**Advertencia**: la encuesta no está publicada. Los usuarios solo pueden ser invitados con los roles de ***$t(auth:authGroups.systemAdmin.label)*** y ***$t(auth:authGroups.surveyAdmin.label)***. Si desea invitar a usuarios con otros roles, primero debe publicar la encuesta.',
    typeEmail: 'Escriba una dirección de correo electrónico y luego presione el botón Añadir',
  },
  user: {
    mapApiKeys: {
      title: 'Claves API del mapa',
      mapProviders: {
        planet: 'Planet',
      },
      keyIsCorrect: 'Esta clave API es válida',
      keyIsNotCorrect: 'Esta clave API NO es válida',
    },
    title: 'Título',
    titleValues: {
      mr: 'Sr',
      ms: 'Sra',
      preferNotToSay: 'Prefiero no decirlo',
    },
  },
  chainView: {
    baseUnit: {
      confirmDelete:
        'Al eliminar la unidad base, se desmarcarán todas las selecciones de "variable basada en área". ¿Continuar?',
    },
    downloadSummaryJSON: 'Descargar resumen (JSON)',
    firstPhaseCategory: 'Categoría de primera fase',
    firstPhaseCategoryInfo: 'Seleccione la categoría que contiene las muestras de la primera fase.',
    firstPhaseCategoryExtraProp: {
      label: 'Atributo de estrato de 1ª fase',
      info: 'Seleccione la variable utilizada para dividir la población original en estratos amplios para la fase inicial de muestreo.',
    },
    firstPhaseCommonAttribute: {
      label: 'Atributo común',
      info: 'Atributo común entre la unidad base y la tabla de primera fase (debe ser un atributo de código con el mismo nombre que una propiedad extra definida para la categoría de primera fase)',
    },
    formLabel: 'Etiqueta de cadena de procesamiento',
    basic: 'Básico',
    records: 'Registros',
    recordsInStepCount: '{{step}}: {{recordsCount}}',
    submitOnlyAnalysisStepDataIntoR: 'Enviar solo datos de pasos de análisis a RStudio',
    submitOnlySelectedRecordsIntoR: 'Enviar solo registros seleccionados a RStudio',
    includeEntitiesWithoutData: 'Incluir entidades sin datos',
    cannotStartRStudio: {
      common: 'No se puede iniciar RStudio',
      noRecords: '$t(chainView.cannotStartRStudio.common): no hay registros para enviar',
      surveyNotPublished: '$t(chainView.cannotStartRStudio.common): primero publique la encuesta',
    },
    nonResponseBiasCorrection: 'Corrección de sesgo por no respuesta',
    nonResponseBiasCorrectionInfo:
      "Para implementar el método de ajuste por clases de ponderación, agregue 'design_psu' y 'design_ssu' a la tabla de categorías del estrato como propiedades numéricas adicionales.",
    pValue: 'Valor P',
    resultsBackFromRStudio: 'Resultados leídos de RStudio',
    resultsBackFromRStudioInfo:
      'Habilite esta opción si los atributos de resultado calculados en RStudio deben importarse de vuelta al servidor de Arena. Este proceso puede ser lento.',
    samplingDesign: 'Diseño de muestreo',
    samplingDesignDetails: 'Detalles del diseño de muestreo',
    samplingStrategyLabel: 'Estrategia de muestreo',
    samplingStrategy: {
      simpleRandom: 'Muestreo aleatorio simple',
      systematic: 'Muestreo sistemático',
      stratifiedRandom: 'Muestreo aleatorio estratificado',
      stratifiedSystematic: 'Muestreo sistemático estratificado',
      twoPhase: 'Muestreo de dos fases',
    },
    statisticalAnalysis: {
      header: 'Análisis estadístico',
      entityToReport: 'Entidad a informar',
      entityWithoutData: 'La entidad {{name}} no tiene datos',
      filter: 'Filtro (script R)',
      reportingMethod: 'Método de informe',
      reportingMethods: {
        dimensionsCombined: 'Combinación de dimensiones',
        dimensionsSeparate: 'Dimensiones por separado',
      },
      reportingArea: 'Área total de informe (ha) (Opcional)',
      reportingAreaInfo: `Con muestreo estratificado, proporcione las áreas de los estratos en la tabla de categorías del atributo de estrato (nombre de la columna 'area')`,
    },
    stratumAttribute: 'Atributo de estrato',
    stratumAttributeInfo: 'Seleccione la variable utilizada para estratificar la muestra.',
    stratumAttribute2ndPhase: 'Atributo de estrato de 2ª fase',
    stratumAttribute2ndPhaseInfo:
      'Seleccione la variable utilizada para subestratificar la muestra de la primera fase antes de extraer la submuestra final y detallada.',
    postStratificationAttribute: 'Atributo de postestratificación',
    areaWeightingMethod: 'Método de ponderación de área',
    clusteringEntity: 'Entidad de agrupación',
    clusteringEntityInfo:
      'La entidad que define las unidades primarias de muestreo. Nota: se utiliza exclusivamente para el análisis de conglomerados dentro del marco del paquete R survey.',
    clusteringOnlyVariances: 'Agrupación solo para varianzas',
    errorNoLabel: 'La cadena debe tener una etiqueta válida',
    dateExecuted: 'Fecha de ejecución',
    deleteChain: 'Eliminar cadena',
    deleteConfirm: '¿Eliminar esta cadena de procesamiento?\n\n$t(common.cantUndoWarning)',
    deleteComplete: 'Cadena de procesamiento eliminada',
    cloneFromAnotherSurvey: 'Clonar desde otro estudio',
    cloneFromAnotherSurveyDialog: {
      title: 'Clonar cadena desde otro estudio',
      sourceSurvey: 'Estudio de origen',
      sourceChain: 'Cadena de origen',
      entityCheck: 'Compatibilidad de entidades',
      entityMissing: 'falta en el estudio destino',
      noAnalysisAttributes: 'Esta cadena no tiene atributos de análisis',
      cloneComplete: 'Cadena clonada correctamente',
      missingEntities: 'No se puede clonar: las siguientes entidades no existen en el estudio destino: {{entities}}',
    },
    cannotSelectNodeDefNotBelongingToCycles:
      'La definición de nodo "{{label}}" no se puede seleccionar porque no pertenece a todos los ciclos de la cadena de procesamiento',
    cannotSelectCycle:
      'Este ciclo no se puede seleccionar porque algunas definiciones de nodo no pertenecen a este ciclo',
    copyRStudioCode:
      '#### Está a punto de abrir un servidor RStudio #### \n\n##### Haga clic en el botón OK y estos comandos se copiarán en su portapapeles. ##### \n\n###### Se abrirá RStudio Server; una vez que la consola de RStudio esté activa, pegue y ejecute las siguientes líneas para importar el código de la cadena: ###### \n\n{{rStudioCode}}\n',
    copyRStudioCodeLocal:
      "#### Cadena de procesamiento a RStudio #### \n\n###### Haga clic en el botón OK y estos comandos se copiarán en su portapapeles. ###### \n\n###### Inicie RStudio en su máquina (debe tener el paquete 'rstudioapi' instalado). ###### \n\n###### Una vez que la consola de RStudio esté activa, pegue y ejecute las siguientes líneas para importar el código de la cadena: ###### \n\n\n{{rStudioCode}}\n\n",
    entities: {
      new: 'Entidad virtual',
    },
    reportingDataCategory: 'Nombre de la tabla de categorías de informes',
    reportingDataAttribute: 'Atributo para {{level}}',
    reportingDataTableAndJoinsWithAttributes: 'Tabla de datos de informes y uniones con atributos',
    showSamplingAttributes: 'Mostrar atributos de muestreo',
  },
  instancesView: {
    title: 'Instancias',
    terminate: 'Terminar',
  },
  chain: {
    quantitative: 'Cuantitativo',
    categorical: 'Categórico',
    addQuantitative: 'Agregar atributo cuantitativo',
    addCategorical: 'Agregar atributo categórico',
    emptyNodeDefs: '$t(validationErrors:analysis.analysisNodeDefsRequired)',
    entityExcludedInRStudioScripts:
      'la entidad y todas las variables de resultado relacionadas se excluirán en los scripts de RStudio',
    entityWithoutData: 'La entidad {{name}} no tiene datos; $t(chain.entityExcludedInRStudioScripts)',
    entityNotInCurrentCycle:
      'La entidad {{name}} no está disponible en el ciclo actual; $t(chain.entityExcludedInRStudioScripts)',
    error: {
      invalidToken: 'Token no válido o caducado',
    },
  },
  itemsTable: {
    unused: 'Sin usar',
    noItemsAdded: 'No se añadieron elementos',
  },
  expression: {
    functionHasTooFewArguments:
      'La función {{fnName}} requiere al menos {{minArity}} argumentos (se obtuvieron {{numArgs}})',
    functionHasTooManyArguments:
      'La función {{fnName}} solo acepta como máximo {{maxArity}} argumentos (se obtuvieron {{numArgs}})',
    identifierNotFound: 'Atributo o entidad "{{name}}" no encontrado',
    invalid: 'Expresión no válida: {{details}}',
    invalidAttributeValuePropertyName:
      'Nombre de propiedad de valor de atributo no válido: {{attributeName}}.{{propName}}',
    invalidCategoryExtraProp: 'Nombre de propiedad extra de categoría no válido: {{propName}}',
    invalidCategotyName: 'Nombre de categoría no válido: {{name}}',
    invalidTaxonomyExtraProp: 'Nombre de propiedad extra de taxonomía no válido: {{propName}}',
    invalidTaxonomyName: 'Nombre de taxonomía no válido: {{name}}',
    invalidTaxonVernacularNameLanguageCode:
      'Código de idioma de nombre vernáculo de taxón no válido: {{vernacularLangCode}}',
    missingFunctionParameters: 'Parámetros de función faltantes',
    undefinedFunction: 'Función indefinida: {{name}}',
  },

  // ====== Help views
  helpView: {
    about: {
      text: `
Acerca de
========

$t(common.appNameFull)
--------
 
 * Desarrollado por: $t(links.openforis)
 * Versión: {{version}}
 * Sitio web: $t(links.openforisArenaWebsite)
 * Tutoriales en video de Arena en la Academia de aprendizaje en línea de FAO: $t(links.arenaVideoTutorialsInFaoElearningAcademy)
 * Tutoriales en video de Arena en YouTube: $t(links.arenaVideoTutorialsInYouTube)
 * Foro de soporte: $t(links.supportForum)
 * Arena en GitHub: $t(links.arenaInGitHub)
 * Scripts R de Arena en GitHub: $t(links.arenaRScriptsInGitHub)
`,
    },
  },
  nodeDefEdit: {
    additionalFields: 'Campos adicionales',
    basic: 'Básico',
    advanced: 'Avanzado',
    mobileApp: 'Aplicación móvil',
    print: 'Impresión',
    printProps: {
      printOrientation: {
        label: 'Orientación de página',
        info: 'Orientación usada cuando esta entidad inicia su propia sección imprimible. Por defecto se hereda la orientación del documento elegida en la exportación.',
      },
      orientations: {
        default: 'Predeterminada (documento)',
        portrait: 'Vertical',
        landscape: 'Horizontal',
      },
    },
    validations: 'Validaciones',
    function: 'Función',
    editingFunction: 'Editando función {{functionName}}',
    editorHelp: {
      json: 'Las expresiones válidas son un subconjunto de Javascript.',
      sql: 'Solo se permiten expresiones SQL válidas.',
    },
    editorCompletionHelp: '- Mostrar las variables y funciones disponibles que se pueden usar',
    functionDescriptions: {
      categoryItemProp:
        'Devuelve el valor de la $t(extraProp.label) especificada de un elemento de categoría que tiene el código especificado',
      dateTimeDiff: 'Devuelve la diferencia (en minutos) de 2 pares de fecha-hora',
      distance: 'Devuelve la distancia (en metros) entre las coordenadas especificadas',
      geoCoordinateAtDistance:
        'Devuelve las coordenadas a una distancia y rumbo especificados desde las coordenadas especificadas',
      geoDistance: '$t(nodeDefEdit.functionDescriptions.distance)',
      first: 'Devuelve el primer valor o nodo del atributo o entidad múltiple especificado',
      geoPolygon: 'Genera un polígono en GeoJSON a partir de una lista de coordenadas',
      includes: 'Devuelve verdadero si el atributo múltiple especificado incluye el valor especificado.',
      index: 'Devuelve el índice del nodo especificado entre sus hermanos',
      isEmpty: 'Devuelve verdadero si el argumento no tiene ningún valor especificado',
      isNotEmpty: 'Devuelve verdadero si el argumento tiene algún valor especificado',
      last: 'Devuelve el último valor o nodo del atributo o entidad múltiple especificado',
      ln: 'Devuelve el logaritmo natural de X',
      log10: 'Devuelve el logaritmo en base 10 de X',
      max: 'Devuelve el máximo de los argumentos',
      min: 'Devuelve el mínimo de los argumentos',
      now: 'Devuelve la fecha u hora actual',
      parent: 'Devuelve la entidad padre del nodo especificado',
      pow: 'Devuelve el valor de una base elevada a una potencia',
      prevCycleNote:
        'Funciona solo en Arena Mobile cuando se definen múltiples ciclos y el enlace al ciclo anterior está habilitado',
      prevCycleValue:
        'Devuelve el valor del mismo atributo en el registro del ciclo anterior. $t(nodeDefEdit.functionDescriptions.prevCycleNote)',
      prevCycleValues:
        'Devuelve los valores de los mismos atributos en el registro del ciclo anterior. $t(nodeDefEdit.functionDescriptions.prevCycleNote)',
      recordCycle: 'Devuelve el ciclo del registro actual',
      recordDateCreated:
        'Devuelve la fecha y hora de creación del registro actual como un valor de fecha y hora. Se puede usar en un atributo de texto, fecha u hora',
      recordDateLastModified:
        'Devuelve la fecha y hora de la última modificación del registro actual como un valor de fecha y hora. Se puede usar en un atributo de texto, fecha u hora',
      recordOwnerEmail: 'Devuelve el correo electrónico del usuario propietario del registro',
      recordOwnerName: 'Devuelve el nombre del usuario propietario del registro',
      recordOwnerRole: 'Devuelve el rol (en la encuesta actual) del usuario propietario del registro',
      rowIndex: 'Devuelve el índice de la fila (o formulario) actual de la tabla',
      taxonProp:
        'Devuelve el valor de la $t(extraProp.label) especificada de un taxón que tiene el código especificado',
      taxonVernacularName:
        'Devuelve el (primer) nombre vernáculo (o local) en el idioma especificado de un taxón que tiene el código especificado',
      userEmail: 'Devuelve el correo electrónico del usuario que ha iniciado sesión',
      userIsRecordOwner:
        'Devuelve un valor booleano "verdadero" si el usuario que edita el registro también es su propietario, "falso" en caso contrario',
      userName: 'Devuelve el nombre del usuario que ha iniciado sesión',
      userProp: 'Devuelve el valor de la $t(extraProp.label) especificada del usuario que ha iniciado sesión',
      uuid: 'Genera un UUID (identificador universalmente único) que se puede usar como identificador (por ejemplo, como atributo clave de una entidad)',
      avg: 'Devuelve el valor promedio de una variable numérica',
      count: 'Devuelve el número de filas que coinciden con un criterio especificado',
      sum: 'Devuelve la suma total de una variable numérica',
    },
    functionName: {
      rowIndex: 'Índice de fila',
    },
    basicProps: {
      analysis: 'Análisis',
      autoIncrementalKey: {
        label: 'Clave auto incremental',
        info: 'El valor se generará automáticamente',
      },
      autoCreateMinCountItems: {
        label: 'Crear mínimo de elementos automáticamente',
        info: 'Cuando la entidad se vuelve relevante o se crea su entidad padre, se generará automáticamente un número de entidades igual al mínimo requerido.',
      },
      displayAs: 'Mostrar como',
      displayIn: 'Mostrar en',
      entitySource: 'Fuente de la entidad',
      enumerate: {
        label: 'Enumerar',
        info: 'Las filas se generarán automáticamente utilizando los elementos de categoría asociados a un atributo de código marcado como Clave definido dentro de la entidad; las filas no se pueden añadir ni eliminar y el atributo de código clave no será editable',
      },
      enumerator: {
        label: 'Enumerador',
        info: 'Los elementos de la categoría se utilizarán para generar las filas de la entidad padre',
      },
      form: 'Formulario',
      formula: 'Fórmula',
      includedInClonedData: 'Incluido en los datos clonados',
      includedInRecordsList: {
        label: 'Incluir en la lista de registros',
        info: `Si está marcado, el atributo será visible en la lista de registros`,
      },
      key: 'Clave',
      maxKeysCountReached: 'Número máximo de claves alcanzado ({{maxKeysCount}})',
      multiple: 'Múltiple',
      ownPage: 'Su propia página',
      parentPage: 'Página padre ({{parentPage}})',
      qualifier: {
        label: 'Calificador',
        info: `Cuando un usuario que pertenece a un grupo crea un nuevo registro, este atributo se completará automáticamente con el valor especificado para él en los calificadores del grupo del usuario. Los usuarios solo podrán ver y modificar los registros que pertenezcan a su propio grupo, si pertenecen a uno.`,
      },
      table: 'Tabla',
    },
    advancedProps: {
      defaultValuesNotSpecified: 'Valores predeterminados no especificados',
      defaultValuesSpecified: 'Valores predeterminados especificados',
      editableAlways: 'Siempre editable',
      editableIfConditionIsMet: 'Editable cuando se cumple la condición',
      relevantIfRadioNone: 'Siempre relevante',
      relevantIfRadioDefined: 'Relevante cuando se cumple la condición',
      visibleAlways: 'Siempre visible',
      visibleIfConditionIsMet: 'Visible cuando se cumple la condición',
      areaBasedEstimate: 'Estimación basada en el área',
      defaultValues: 'Valores predeterminados',
      defaultValuesInfo: `Esto permite completar automáticamente una respuesta según reglas específicas.
    Si configura varias reglas, el sistema las comprobará en orden, de arriba hacia abajo.
    Aplicará la primera regla que cumpla las condiciones y usará ese resultado como respuesta.`,
      defaultValueEvaluatedOneTime: 'Valor predeterminado evaluado solo una vez',
      defaultValueEvaluatedOneTimeInfo: `El valor predeterminado se evaluará solo una vez, cuando se cree el atributo.
    Si no está marcado, el valor predeterminado se volverá a evaluar cada vez que se actualice el registro.
    Debe marcarse al usar expresiones como now() o uuid(), que deben evaluarse solo una vez, cuando el valor del atributo se genera por primera vez.`,
      defaultValuesNotEditableForAutoIncrementalKey:
        'Valores predeterminados no editables porque la clave auto incremental está configurada',
      editableIf: 'Editable si',
      editableIfInfo: `Por defecto, un usuario siempre puede acceder a un campo relevante.
Aquí se puede definir una regla para indicar si el usuario puede escribir o modificar este campo.
Esto decide si un usuario puede escribir o cambiar este campo.
Si se cumplen las condiciones definidas, el campo se puede editar. Si no, será de solo lectura (bloqueado).`,
      hidden: 'Siempre oculto',
      hiddenInReport: 'Ocultar en el Panel Analítico',
      hiddenInReportInfo: `Si está marcado, el atributo no será visible en el Panel Analítico`,
      hiddenWhenNotRelevant: 'Oculto cuando no es relevante',
      itemsFilter: 'Filtro de elementos',
      itemsFilterInfo:
        'Expresión utilizada para filtrar elementos seleccionables. En la expresión, la palabra "this" se referirá al elemento en sí. Ej.: this.region = region_attribute_name (donde "region" es el nombre de una propiedad extra definida para el elemento y region_attribute_name es el nombre de un atributo en la encuesta)',
      readOnly: 'Solo lectura',
      relevantIf: 'Relevante si',
      relevantIfInfo: `Por defecto, todos los campos están activos.
    Si define una regla de relevancia y no se cumple, el campo se mostrará en gris o se ocultará por completo,
    y las respuestas automáticas se ignorarán.
    Úselo para mostrar u ocultar partes de la encuesta de forma dinámica; por ejemplo, mostrar "Especifique" solo cuando el usuario elige "Otro".`,
      script: 'Script',
      visibleIf: 'Visible si',
      visibleIfInfo: `Por defecto, un campo siempre es visible.
    Si define una regla, solo será visible cuando esa regla se cumpla; en caso contrario, quedará oculto.
    Nota: a diferencia de ocultar un campo "no relevante", un campo oculto puede seguir guardando una respuesta automática.
    Esto es útil para ocultar secciones completas de la encuesta según quién haya iniciado sesión (por ejemplo, por rol).`,
    },
    mobileAppProps: {
      hiddenInMobile: {
        label: 'Oculto en Arena Mobile',
        info: 'Si está marcado, el atributo no será visible en AM',
      },
      includedInMultipleEntitySummary: {
        label: 'Incluir en el resumen de entidades múltiples',
        info: 'Si está marcado, el atributo será visible en la vista de resumen de la entidad',
      },
      includedInPreviousCycleLink: {
        label: 'Incluir en el enlace del ciclo anterior',
        info: 'Si está marcado, el valor del ciclo anterior se mostrará en el formulario de entrada de datos (cuando el enlace al ciclo anterior esté activo en la aplicación móvil)',
      },
    },
    numericProps: {
      unit: 'Unidad',
    },
    decimalProps: {
      maxNumberDecimalDigits: 'Número máximo de dígitos decimales',
    },
    fileProps: {
      fileNameExpression: 'Expresión de nombre de archivo',
      fileType: 'Tipo de archivo',
      fileTypes: {
        image: 'Imagen',
        video: 'Video',
        audio: 'Audio',
        other: 'Otro',
      },
      maxFileSize: 'Tamaño máximo de archivo (Mb)',
      numberOfFiles: 'Vaya a Validaciones para cambiar el número mínimo y máximo de archivos.',
      showGeotagInformation: 'Mostrar información de geoetiqueta',
    },
    mobileProps: {
      title: 'Aplicación móvil',
    },
    formHeaderProps: {
      headerColorLabel: 'Color de encabezado',
      headerColor: {
        blue: 'Azul',
        green: 'Verde',
        orange: 'Naranja',
        red: 'Rojo',
        yellow: 'Amarillo',
      },
    },
    textProps: {
      displayAsTypes: {
        hyperlink: 'Hipervínculo',
        markdown: 'Markdown',
        text: 'Texto',
      },
      textInputType: 'Tipo de entrada de texto',
      textInputTypes: {
        singleLine: 'Una sola línea',
        multiLine: 'Varias líneas',
      },
      textTransform: 'Transformación de texto',
      textTransformTypes: {
        none: 'ninguno',
        capitalize: 'capitalizar',
        uppercase: 'mayúsculas',
        lowercase: 'minúsculas',
      },
    },
    booleanProps: {
      labelValue: 'Valor de la etiqueta',
      labelValues: {
        trueFalse: '$t(common.true)/$t(common.false)',
        yesNo: '$t(common.yes)/$t(common.no)',
      },
    },
    codeProps: {
      category: 'Categoría',
      codeShown: 'Mostrar código',
      displayAsTypes: {
        checkbox: 'Casilla de verificación',
        dropdown: 'Desplegable',
      },
      parentCode: 'Código padre',
    },
    coordinateProps: {
      allowOnlyDeviceCoordinate: 'Permitir solo coordenadas del dispositivo',
      allowOnlyDeviceCoordinateInfo:
        'Solo se aplica a Arena Mobile: si está marcado, el usuario no podrá modificar los valores X/Y, solo se podrá usar el GPS del dispositivo para obtenerlos',
      mapMarkerColor: 'Color del marcador en el mapa',
    },
    expressionsProp: {
      expression: 'Expresión',
      applyIf: 'Aplicar si',
      confirmDelete: '¿Eliminar esta expresión?',
      severity: 'Severidad',
    },
    validationsProps: {
      minCount: 'Conteo mínimo',
      maxCount: 'Conteo máximo',
      expressions: 'Expresiones de validación',
      attributeAlwaysValid: 'Atributo siempre válido',
      attributeValidWhenConditionIsMet: 'Atributo válido cuando se cumple la condición',
    },
    cannotChangeIntoMultipleWithDefaultValues:
      'Este nodo no se puede convertir a múltiple porque tiene valores predeterminados.',
    cannotDeleteNodeDefReferenced:
      'No se puede eliminar "{{nodeDef}}": está referenciado por estas definiciones de nodo: {{nodeDefDependents}}',
    cloneDialog: {
      confirmButtonLabel: 'Clonar',
      title: 'Clonando definición de nodo "{{nodeDefName}}"',
      entitySelectLabel: 'Entidad en la que clonar:',
    },
    conversion: {
      dialogTitle: 'Convertir {{nodeDefName}} a otro tipo',
      fromType: 'De tipo',
      toType: 'A tipo',
    },
    moveDialog: {
      confirmButtonLabel: 'Mover',
      title: 'Moviendo la definición del nodo "{{nodeDefName}}" desde "{{parentNodeDefName}}"',
      entitySelectLabel: 'Entidad a la que mover:',
    },
    movedNodeDefinitionHasErrors:
      'La definición de nodo "{{nodeDefName}}" que ha movido tiene errores; por favor, corríjalos.',
    nodeDefintionsHaveErrors: 'Estas definiciones de nodo tienen errores: {{nodeDefNames}}. Por favor, corríjalos.',
    filterVariable: 'Variable para filtrar elementos',
    filterVariableForLevel: 'Variable para {{levelName}}',
    unique: {
      label: 'Único',
      info: 'Cuando un atributo está marcado como **Único**, su valor debe ser único dentro de la entidad múltiple más cercana (se mostrará un error en caso contrario). \n\n---\n\nEj.: en una estructura como *clúster -> parcela -> árbol*, si tiene un atributo *tree_species* marcado como **Único**, solo puede tener un árbol por especie dentro de la misma *parcela*.',
    },
    categoriesClonedFromSurvey: 'Las siguientes categorías también se clonaron desde la encuesta de origen: {{names}}',
    taxonomiesClonedFromSurvey: 'Las siguientes taxonomías también se clonaron desde la encuesta de origen: {{names}}',
  },
  languagesEditor: {
    languages: 'Idioma(s)',
  },
  taxonomy: {
    header: 'Taxonomía',
    cantBeDeleted: "$t(common.cantBeDeletedUsedItem, {'item': 'taxonomía'})",
    confirmDelete: '¿Eliminar la taxonomía {{taxonomyName}}?\n$t(common.cantUndoWarning)',
    cloneFromAnotherSurvey: {
      title: 'Clonar taxonomía de otra encuesta',
      sourceSurvey: 'Encuesta de origen',
      sourceTaxonomy: 'Taxonomía de origen',
      loadingSurveys: 'Cargando encuestas...',
      noSurveysAvailable: 'No hay encuestas disponibles',
      selectSurveyFirst: 'Seleccione primero una encuesta',
      loadingTaxonomies: 'Cargando taxonomías...',
      noTaxonomiesAvailable: 'No hay taxonomías disponibles en la encuesta seleccionada',
    },
    edit: {
      taxonomyListName: 'Nombre de la lista de taxonomía',
      taxaNotImported: 'Taxones no importados',
      family: 'Familia',
      genus: 'Género',
      scientificName: '$t(surveyForm:nodeDefTaxon.scientificName)',
      synonym: 'Sinónimo / Latín',
      extraPropsNotDefined: 'Propiedades extra no definidas para esta taxonomía',
      importMissingPublishedTaxa:
        '{{count}} taxón/taxa publicado/s no encontrado/s en el archivo importado y dejado/s sin cambios. Códigos: {{codes}}',
      importMissingPublishedTaxaTruncated: '$t(taxonomy.edit.importMissingPublishedTaxa) (+{{extra}} más)',
    },
    taxaCount: 'Recuento de taxones',
    vernacularNameLabel: 'Etiqueta de nombre vernáculo',
  },
  categoryList: {
    batchImport: 'Importar categorías en lote (desde ZIP)',
    batchImportCompleteSuccessfully:
      '¡{{importedCategories}} categorías importadas correctamente!\n{{insertedCategories}} nuevas\n{{updatedCategories}} actualizadas',
    cloneFromAnotherSurvey: {
      title: 'Clonar categoría de otra encuesta',
      sourceSurvey: 'Encuesta de origen',
      sourceCategory: 'Categoría de origen',
      loadingSurveys: 'Cargando encuestas...',
      noSurveysAvailable: 'No hay encuestas disponibles',
      selectSurveyFirst: 'Seleccione primero una encuesta',
      loadingCategories: 'Cargando categorías...',
      noCategoriesAvailable: 'No hay categorías disponibles en la encuesta seleccionada',
    },
    itemsCount: 'Recuento de elementos',
    types: {
      flat: 'Plana',
      hierarchical: 'Jerárquica',
      reportingData: 'Datos de informes',
    },
  },
  categoryEdit: {
    header: 'Categoría',
    addLevel: 'Añadir nivel',
    categoryName: 'Nombre de la categoría',
    cantBeDeleted: "$t(common.cantBeDeletedUsedItem, {'item': 'categoría'})",
    cantBeDeletedLevel: "$t(common.cantBeDeletedUsedItem, {'item': 'nivel de categoría'})",
    confirmDelete: '¿Eliminar la categoría {{categoryName}}?\n$t(common.cantUndoWarning)',
    confirmDeleteEmptyCategory: 'La categoría está **vacía** y se eliminará. ¿Continuar?',
    confirmDeleteLevel:
      "¿Eliminar el nivel de categoría '{{levelName}}' con todos los elementos?\n$t(common.cantUndoWarning)",
    confirmDeleteItem: '¿Eliminar el elemento?\n\n$t(common.cantUndoWarning)',
    confirmDeleteItemWithChildren: '¿Eliminar el elemento con todos los hijos?\n\n$t(common.cantUndoWarning)',
    convertToReportingDataCategory: {
      buttonLabel: 'Convertir a datos de informes',
      confirmMessage:
        "¿Convertir esta categoría a una categoría de datos de informes?\n\nLos niveles se renombrarán a level_1, level_2... level_N y se añadirá una propiedad extra 'area' a los elementos.",
    },
    convertToSimpleCategory: {
      confirmMessage: '¿Convertir esta categoría de datos de informes a una categoría simple?',
    },
    deleteItem: 'Eliminar elemento',
    level: {
      title: 'Nivel {{levelPosition}}',
      noItemsDefined: 'No se definieron elementos',
      selectItemFromPreviousLevel: 'Seleccione un elemento del nivel anterior',
    },
    importSummary: {
      columns: 'Columna',
      columnTypeSummary: 'Nivel {{level}} $t(categoryEdit.importSummary.columnType.{{type}})',
      columnTypeExtra: '$t(extraProp.label)',
      columnTypeDescription: 'Descripción ({{language}})',
      columnTypeLabel: 'Etiqueta ({{language}})',
      columnType: {
        code: 'código',
        description: 'descripción',
        label: 'etiqueta',
        extra: '$t(extraProp.label)',
      },
      dataType: 'Tipo de datos',
      title: 'Resumen de importación de categoría',
    },
    reportingData: 'Datos de informes',
    templateFor_samplingPointDataImport_csv: 'Plantilla para importación de datos de puntos de muestreo (CSV)',
    templateFor_samplingPointDataImport_xlsx: 'Plantilla para importación de datos de puntos de muestreo (Excel)',
  },
  extraProp: {
    label: 'Propiedad extra',
    label_plural: 'Propiedades extra',
    addExtraProp: 'Añadir propiedad extra',
    dataTypes: {
      geometryPoint: 'Punto de geometría',
      number: 'Número',
      text: 'Texto',
    },
    editor: {
      title: 'Editar $t(extraProp.label_plural)',
      confirmDelete: '¿Eliminar la propiedad extra "{{name}}"?',
      confirmSave:
        '¿Guardar los cambios en las definiciones de propiedades extra?\n\n**Advertencias**:\n\n{{warnings}}',
      warnings: {
        nameChanged: 'Nombre cambiado de {{nameOld}} a {{nameNew}}',
        dataTypeChanged: 'Tipo de datos cambiado de {{dataTypeOld}} a {{dataTypeNew}}',
      },
    },
    name: 'Nombre de la propiedad {{position}}',
    value: 'Valor',
  },
  record: {
    ancestorNotFound: 'Nodo ancestro no encontrado en el registro',
    keyDuplicate: 'Clave de registro duplicada',
    oneOrMoreInvalidValues: 'Uno o más valores no son válidos',
    uniqueAttributeDuplicate: 'Valor duplicado',
    attribute: {
      customValidation: 'Valor no válido',
      uniqueDuplicate: 'Valor duplicado',
      valueInvalid: 'Valor no válido',
      valueRequired: 'Valor requerido',
    },
    entity: {
      keyDuplicate: 'Clave de entidad duplicada',
    },
    nodes: {
      count: {
        invalid: 'Los nodos {{nodeDefName}} deben ser exactamente {{count}}',
        maxExceeded: 'Los nodos {{nodeDefName}} deben ser menores o iguales a {{maxCount}}',
        minNotReached: 'Los nodos {{nodeDefName}} deben ser mayores o iguales a {{minCount}}',
      },
    },
  },
  expressionEditor: {
    and: 'Y',
    or: 'O',
    group: 'Grupo ()',
    var: 'Variable',
    const: 'Valor constante',
    call: 'Función',
    operator: 'Operador',
    geoCoordinateAtDistanceEditor: {
      coordinateAttributeOrigin: 'Atributo de coordenada de origen',
      distanceAttribute: 'Atributo de distancia',
      bearingAttribute: 'Atributo de rumbo',
    },
    coordinateAttributeWithPosition: 'Atributo de coordenada {{position}}',
    dateTimeDiffEditor: {
      firstDateAttribute: 'Primer atributo de fecha',
      firstTimeAttribute: 'Primer atributo de hora',
      secondDateAttribute: 'Segundo atributo de fecha',
      secondTimeAttribute: 'Segundo atributo de hora',
    },
    error: {
      selectOneVariable: 'Por favor, seleccione una variable',
    },
    header: {
      editingExpressionForNodeDefinition: 'Editando expresión {{qualifier}} para "{{nodeDef}}"',
      editingFunctionForNodeDefinition: 'Editando función "{{functionName}}" para "{{nodeDef}}"',
    },
    qualifier: {
      'default-values': 'valor predeterminado',
      'default-values-apply-if': 'aplicar si el valor predeterminado',
      'editable-if': 'editable si',
      'max-count': 'recuento máximo',
      'min-count': 'recuento mínimo',
      'relevant-if': 'relevante si',
      validations: 'regla de validación',
      'validations-apply-if': 'aplicar si la regla de validación',
      'visible-if': 'visible si',
    },
    selectAFunction: 'Seleccionar una función',
    valueType: {
      constant: 'Constante',
      expression: 'Expresión',
    },
  },
}
